exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button-push{\nposition: absolute;\ntop: 49vh;\nleft: -26px;\n}\n.button-push:hover,.button-pop-up:hover{\ncursor: pointer;\n}\n.image-button{\ncolor: black;\nfont-size: 24px;\n}\n", ""]);

// exports
